import api from './api';

export async function getDeposits() {
  const { data } = await api.get('/deposit');
  return data;
}

export async function getDepositById(id) {
  const { data } = await api.get(`/deposit/${id}`);
  return data;
}

export async function createDeposit(payload) {
  const { data } = await api.post('/deposit', payload);
  return data;
}

export async function updateDeposit(id, payload) {
  const { data } = await api.put(`/deposit/${id}`, payload);
  return data;
}

export async function changeStateDeposit(id) {
  const { data } = await api.get(`/deposit/change-state/${id}`);
  return data;
}

export async function changeMainDeposit(id) {
  const { data } = await api.get(`/deposit/change-main/${id}`);
  return data;
}

export async function deleteDeposit(id) {
  const { data } = await api.delete(`/deposit/${id}`);
  return data;
}
